import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

const WIDTH = 50;
const WIDTH_MOBILE = 30;
const RING_OFFSET = 4;

type ExteriorImageType = {
    image?: string;
    rgb?: string;
    isSelected?: boolean;
    zoomedIn: boolean;
    lightColour: boolean;
};

export const ExteriorImage = styled.div<ExteriorImageType>`
    position: relative;
    top: 0;
    width: ${WIDTH_MOBILE}px;
    min-width: ${WIDTH_MOBILE}px;
    height: ${WIDTH_MOBILE}px;
    background-color: transparent;
    border-radius: 50%;

    &::before {
        position: absolute;
        top: -${RING_OFFSET}px;
        left: -${RING_OFFSET}px;
        width: calc(100% + ${RING_OFFSET * 2}px);
        height: calc(100% + ${RING_OFFSET * 2}px);
        content: "";
        border: 1px solid transparent;
        border-color: ${({ isSelected }) => (isSelected ? theme.colors.steel : "transparent")};
        border-radius: 50%;
        transition: border-color 0.3s;
    }

    ${({ image, zoomedIn }) =>
        image &&
        css`
            background-image: url(${image});
            background-position: center;
            background-size: ${!zoomedIn ? "100%" : "55px"};
            border-radius: 0;
            &::before {
                border-radius: 0;
            }
        `};

    ${({ rgb, image }) =>
        rgb &&
        !image &&
        css`
            background-color: ${`#${rgb.substr(0, 2) === "0x" ? rgb.substr(2) : rgb}`};
        `};

    @media ${getBreakpoint("up", "md")} {
        width: ${WIDTH}px;
        height: ${WIDTH}px;
    }
`;

export const Text = styled.span`
    display: block;
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.black};
`;

export const ItemWrapper = styled.li<{ hasBorder?: boolean }>`
    display: flex;
    align-items: center;
    gap: ${theme.space[3]}px;
    margin: 0;
    padding: 0;
    cursor: pointer;

    &:not(:last-of-type) {
        margin-bottom: ${theme.space[2]}px;
    }

    ${({ hasBorder }) =>
        hasBorder &&
        css`
            padding: ${theme.space[3]}px 0;
            border-bottom: 1px solid ${theme.colors.platinumLight};

            &:not(:last-of-type) {
                margin-bottom: 0;
            }
        `};
`;

export const Wrapper = styled.ul`
    display: block;
    margin: 0 0 ${theme.space[4]}px;
    padding: 0;
`;
